/*
  Copyright 2018-2020 National Geographic Society

  Use of this software does not constitute endorsement by National Geographic
  Society (NGS). The NGS name and NGS logo may not be used for any purpose without
  written permission from NGS.

  Licensed under the Apache License, Version 2.0 (the "License"); you may not use
  this file except in compliance with the License. You may obtain a copy of the
  License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software distributed
  under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
  CONDITIONS OF ANY KIND, either express or implied. See the License for the
  specific language governing permissions and limitations under the License.
*/

import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import { noop } from 'lodash';
import React from 'react';

import { ErrorMessageProps } from './model';

const useStyles = makeStyles(theme => ({
  root: {
    zIndex: 10010,
  },
}));

export function ErrorMessages(props: ErrorMessageProps) {
  const { autoHideDuration = 5000, className, disableAutoHide, errors, onClose = noop } = props;

  const classes = useStyles();

  return (
    <Snackbar
      className={`${classes.root} ${className} marapp-qa-errormessages`}
      open={!!errors?.length}
      autoHideDuration={disableAutoHide ? null : autoHideDuration}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <Alert onClose={onClose} variant="filled" severity="error">
        {errors &&
          errors.map &&
          errors.map((error, index) => (
            <Typography key={index}>
              {error.title ? `${error.title}: ` : ``}
              {error.detail}
              {error.source && (
                <>
                  <br />
                  <code>
                    {error.source.pointer} {error.source.body}
                    {/* enable this in a debug mode? */}
                    {/* {' '}{Object.entries(error.source.parameter || {}).map(([k,v]) => (
                      `${k}=${v}`
                    ))
                  } */}
                  </code>
                </>
              )}
            </Typography>
          ))}
      </Alert>
    </Snackbar>
  );
}
